(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2219],{

/***/ 6712:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image/[[...slug]]",
      function () {
        return __webpack_require__(29500);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LicenseNote; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


// The library licence as stated on /pricing and in its FAQ. Keep in step with
// those pages and with IMAGE_LICENSE in services/structured-data.js.
function LicenseNote(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _label = param.label, label = _label === void 0 ? "License:" : _label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                className: "font-semibold",
                children: [
                    label,
                    " "
                ]
            }),
            "Free for personal and educational use. Commercial use requires a",
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/pricing",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: "underline hover:text-secondary",
                    children: "paid plan"
                })
            }),
            "."
        ]
    });
}


/***/ }),

/***/ 29500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _heroicons_react_24_solid__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24993);
/* harmony import */ var _components_DownloadButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22508);
/* harmony import */ var _components_LicenseNote__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1336);
/* harmony import */ var _components_IndexLayout3__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41850);
/* harmony import */ var _services_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75681);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _services_meta__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4586);
/* harmony import */ var _services_structured_data__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90138);












function ImageContent(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isDownloadingPNG = ref[0], setIsDownloadingPNG = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isDownloadingSVG = ref1[0], setIsDownloadingSVG = ref1[1];
    var image = props.image, url = props.url, description = props.description;
    var downloadSVG = function() {
        setIsDownloadingSVG(true);
        var url = "/api/download/" + image;
        (0,_services_utils__WEBPACK_IMPORTED_MODULE_7__/* .downloadImage */ .G)(url, "svg").catch(function(err) {
            var ref, ref1;
            if ((err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.status) === 400) {
                window.location.href = "/login";
            } else if ((err === null || err === void 0 ? void 0 : (ref1 = err.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                window.location.href = "/pricing";
            }
        }).finally(function() {
            setIsDownloadingSVG(false);
        });
    };
    var downloadPNG = function() {
        setIsDownloadingPNG(true);
        var url = "/api/download/" + image + "?png=1";
        (0,_services_utils__WEBPACK_IMPORTED_MODULE_7__/* .downloadImage */ .G)(url, "png").catch(function(err) {
            var ref, ref1;
            if ((err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.status) === 400) {
                window.location.href = "/login";
            } else if ((err === null || err === void 0 ? void 0 : (ref1 = err.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                window.location.href = "/pricing";
            }
        }).finally(function() {
            setIsDownloadingPNG(false);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col sm:flex-row mx-4 my-32 mb-8 sm:mb-16 sm:mx-8 lg:mx-32 xl:mx-48 2xl:mx-96 mt-8 sm:mt-16 text-2xl lg:text-2xl xl:text-5xl text-white font-semibold text-left",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "aspect-square rounded-md overflow-hidden m-3 sm:m-2 lg:m-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    className: "list-image rounded-md object-cover w-full h-full",
                    src: url,
                    srcSet: "".concat(url.replace("/sm", "/xxs"), " 276w, ").concat(url.replace("/sm", "/xs"), " 384w, ").concat(url, " 512w"),
                    size: "(max-width: 600px) 276px, (max-width: 1200px) 384px, 512px",
                    alt: (0,_services_meta__WEBPACK_IMPORTED_MODULE_8__/* .itemAltText */ .Z5)(props),
                    style: {
                        minHeight: 128,
                        minWidth: 128,
                        maxWidth: 1024
                    }
                }, url)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col text-2xl font-medium sm:ml-6 text-white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "flex-1",
                        children: lodash__WEBPACK_IMPORTED_MODULE_1___default().capitalize(description)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "justify-end",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-2 focus:outline-none flex",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "/edit/".concat(image),
                                        target: "_blank",
                                        rel: "nofollow noreferrer",
                                        className: "focus:outline-none flex-1 mr-1",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                            type: "button",
                                            className: "items-center inline-flex w-full ring-0 outline-none justify-center rounded-md border border-gray-300 bg-white pl-4 px-2 py-2 font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:col-start-1 sm:mt-0 text-xs",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_24_solid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                    className: "w-3 h-3"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex-1",
                                                    children: "Edit image"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "/create?prompt=".concat(encodeURIComponent(description)),
                                        target: "_blank",
                                        rel: "nofollow noreferrer",
                                        className: "focus:outline-none flex-1 ml-1",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                            type: "button",
                                            className: "items-center inline-flex w-full ring-0 outline-none justify-center rounded-md border border-gray-300 bg-white pl-3 px-2 py-2 font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:col-start-1 sm:mt-0 text-xs",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-lg mr-1 sparkle w-3",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        alt: "Create similar",
                                                        src: "/sparkle-black.svg"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex-1",
                                                    children: "Create similar"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full mt-6 sm:mt-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DownloadButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    loading: isDownloadingSVG || isDownloadingPNG,
                                    onDownloadSvg: function() {
                                        return downloadSVG();
                                    },
                                    onDownloadPng: function() {
                                        return downloadPNG();
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LicenseNote__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                className: "mt-3 text-sm font-normal text-gray-200"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var __N_SSP = true;
function Home(props) {
    var ref;
    var ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_IndexLayout3__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, props), {
        title: props.initialItem ? (0,_services_meta__WEBPACK_IMPORTED_MODULE_8__/* .itemPageTitle */ .z4)(props.initialItem) : undefined,
        description: props.initialItem ? (0,_services_meta__WEBPACK_IMPORTED_MODULE_8__/* .itemMetaDescription */ .Fh)(props.initialItem) : undefined,
        image: (0,_services_meta__WEBPACK_IMPORTED_MODULE_8__/* .itemShareImageUrl */ .U)(props.initialItem) || undefined,
        jsonLd: props.initialItem ? (0,_services_structured_data__WEBPACK_IMPORTED_MODULE_6__/* .imagePageJsonLd */ .e8)(props.initialItem, {
            generated: !!props.initialItem.library
        }) : undefined,
        permalink: props.permalink || (props.initialItem ? "https://vectorart.ai/image/".concat(props.initialItem.image, "/").concat(encodeURI((ref1 = (ref = props.initialItem.description) === null || ref === void 0 ? void 0 : ref.slice(0, 100)) !== null && ref1 !== void 0 ? ref1 : "")) : null),
        headerContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageContent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, props.initialItem))
    }));
}


/***/ }),

/***/ 24993:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function PaintBrushIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M20.599 1.5c-.376 0-.743.111-1.055.32l-5.08 3.385a18.747 18.747 0 00-3.471 2.987 10.04 10.04 0 014.815 4.815 18.748 18.748 0 002.987-3.472l3.386-5.079A1.902 1.902 0 0020.599 1.5zm-8.3 14.025a18.76 18.76 0 001.896-1.207 8.026 8.026 0 00-4.513-4.513A18.75 18.75 0 008.475 11.7l-.278.5a5.26 5.26 0 013.601 3.602l.502-.278zM6.75 13.5A3.75 3.75 0 003 17.25a1.5 1.5 0 01-1.601 1.497.75.75 0 00-.7 1.123 5.25 5.25 0 009.8-2.62 3.75 3.75 0 00-3.75-3.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(PaintBrushIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,203,4878,5121,2713,5675,6407,617,2055,4238,7430,3115,1850,9774,2888,179], function() { return __webpack_exec__(6712); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);